<template>
  <div class="h-full d-flex align-center justify-center">
    <div v-if="carregando_dados" class="position-absolute text-center z-1">
      <v-progress-circular color="red" indeterminate size="40" width="3" />
      <p class="ma-0 font-14 mt-2 text-gray-900">Carregando... aguarde</p>
    </div>

    <div class="w-full h-full">
      <apexchart
        height="100%"
        type="bar"
        :options="options"
        :series="SERIES"
      />
    </div>
  </div>
</template>

<script>
import {buscarSaidasPrimeiroSemestreProduto} from "@/api/compraPorProdutosGerais/Heranca";
import {logout} from "@/helpers";
import formatarValoresBi from "@/helpers/formatarValoresBi";

export default {
  name: "SaidasPrimeiroSemestreProduto",
  props: {
    produto: Object,
  },
  data: () => ({
    options: {
      chart: {
        type: "bar",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        toolbar: {
          show: false
        }
      },
      title: {
        text: 'Saídas do primeiro semestre de vendas',
        align: 'left',
        offsetX: 10,
        offsetY: 12,
        floating: false,
        style: {
          fontSize:  '14px',
          fontWeight:  'bold',
          color: '#263238'
        },
      },
      plotOptions: {
        bar: {
          endingShape: "rounded",
          dataLabels: {
            position: "top",
            orientation: "vertical"
          }
        }
      },
      grid: {
        show: true,
        yaxis: {
          lines: {
            show: true
          }
        },
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      labels: [0, 0, 0, 0, 0, 0],
      legend: {
        show: true,
        position: "top",
        offsetY: 13,
        markers: {
          width: 13,
          height: 13,
          radius: 2
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: 4,
        style: {
          fontSize: "11px",
          fontWeight: 0,
          colors: ["#000"]
        },
        formatter: function(val) {
          if (!val || val == 0) {
            return '';
          }

          if (val < 1000) {
            return val;
          }

          return formatarValoresBi(val);
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        labels: {
          minWidth: 50,
          maxWidth: 50,
          style: {
            fontSize: "0.72rem"
          },
          formatter: val => {
            if (val === 0) {
              return 'Mês';
            }

            const [mes_str, ano] = `${val}`.split(' ');
            return `${mes_str.substring(0, 3)}/${ano.substring(2, 4)}`;
          }
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        forceNiceScale: true,
        title: {
          text: "",
          style: {
            color: "#000",
            fontSize: "12px",
            fontWeight: 600,
            cssClass: "apexcharts-yaxis-title"
          }
        }
      },
      tooltip: {
        enabled: true,
        x: {
          show: true,
          formatter: valor => {
            return valor;
          }
        }
      }
    },
    carregando_dados: true,
    dados_grafico: {
      saidas: [0, 0, 0, 0, 0, 0],
    }
  }),
  watch: {
    produto() {
      this.buscarDados();
    }
  },
  mounted() {
    this.buscarDados();
  },
  computed: {
    SERIES() {
      return [
        {
          name: "",
          color: "rgba(214, 14, 43,1)",
          data: this.dados_grafico.saidas
        }
      ];
    }
  },
  methods: {
    buscarDados() {
      this.carregando_dados = true;

      buscarSaidasPrimeiroSemestreProduto(this.produto)
        .then(dados_grafico => {
          this.dados_grafico = dados_grafico;
          this.carregando_dados = false;

          const valor_maximo_saida = this.dados_grafico.saidas.reduce((a, b) => Math.max(a, b));

          this.options = {
            yaxis: {
              ...this.options.yaxis,
              max: valor_maximo_saida + (valor_maximo_saida / 3)
            },
            labels: this.dados_grafico.referencias
          }
        })
        .catch(logout)
    }
  }
}
</script>

<style scoped>

</style>
